"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPINNER_DOT_SIZES_MAP = exports.SPINNER_CONTAINER_SIZES_MAP = void 0;
const SPINNER_CONTAINER_SIZES_MAP = {
  small: 10,
  medium: 16,
  xLarge: 28
};
exports.SPINNER_CONTAINER_SIZES_MAP = SPINNER_CONTAINER_SIZES_MAP;
const SPINNER_DOT_SIZES_MAP = {
  small: 3,
  medium: 4,
  xLarge: 7
};
exports.SPINNER_DOT_SIZES_MAP = SPINNER_DOT_SIZES_MAP;
//# sourceMappingURL=constants.js.map